module.exports = __webpack_public_path__ + "img/icon0.054f2d47.png";